import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { config } from '../config';

const Footer = () => {
  const { t } = useTranslation();
  const emailContact = t('email contact');
  const website = t('website');
  const helpdeskPhone = t('helpdesk phone number');

  return (
    <footer className="footer">
      <ul className="flex list-none flex-col p-2 justify-between xl:flex-row ml-2 xl:ml-8 xl:mr-8">
        {config.helpdeskEnabled && (
          <li>
            <div className="text-xl font-semibold mb-0 xl:mb-4">{t('contact helpdesk')}</div>
            <div>
              <Link to="/help">{t('contact helpdesk description')}</Link>
            </div>
          </li>
        )}
        <li>
          <div className="text-xl font-semibold mb-0 xl:mb-4">{t('support')}</div>
          {helpdeskPhone !== '' ? (
            <div>
              {t('tel helpdesk')}{' '}
              <a target="_blank" href={`tel:+39${helpdeskPhone}`} rel="noreferrer">
                {helpdeskPhone}
              </a>
            </div>
          ) : null}
          <div>
            EMAIL{' '}
            <a target="_blank" href={`mailto:${emailContact}`} rel="noreferrer">
              {emailContact}
            </a>
          </div>
        </li>
        <li>
          <div className="text-xl font-semibold mb-0 xl:mb-4">{t('privacy policy title')}</div>
          <div className="max-w-md">{t('privacy policy description')}</div>
          <div>
            <a
              target="_blank"
              href="https://www.gdsuite.it/docs/Mod.Informativa_NGB_Dati_Sensibili_2018_v.1.pdf"
              rel="noreferrer"
            >
              {t('privacy policy link')}
            </a>
          </div>
        </li>
      </ul>
      <div className="footer-text p-2 text-sm text-center">
        <span
          dangerouslySetInnerHTML={{
            __html: t('footer text part2', {
              boldStart: '<span class="font-medium">',
              boldEnd: '</span>',
              linkStart: `<a href="${website}" target="new">`,
              linkEnd: '</a>',
            }),
          }}
        ></span>
      </div>
    </footer>
  );
};
export default Footer;
